const translation = {
  // Navbar
  nav_hotel_intro: '酒店介绍',
  nav_greeting: '问候语',
  nav_about: '酒店介绍',
  nav_rooms: '客房介绍',
  nav_services: '附属设施',
  nav_nearby: '周边指南',
  nav_refund: '退款规定',
  nav_contact: '交通指南',
  nav_support: '客户支持',
  nav_reserve: '在线预订',

  // Hero
  hero_welcome: '欢迎来到韩国 · 东大门',
  hero_title: 'YOUNGBIN HOTEL',
  hero_subtitle: '欢迎光临英宾酒店',
  hero_location: '首尔东大门',
  hero_cta_reserve: '立即预订',
  hero_cta_rooms: '查看客房',
  hero_slide1_label: '舒适休憩的空间',
  hero_slide2_label: '温馨客房',
  hero_slide3_label: '整洁现代的浴室',
  hero_slide4_label: '东大门市中心绝佳位置',
  hero_slide5_label: '为旅行者而生的英宾酒店',

  // About
  about_tag: '欢迎光临英宾酒店',
  about_title: '东大门中心，\n英宾酒店',
  about_desc1: '英宾酒店毗邻首尔特别市中区东大门国际时装城。距东大门购物商圈步行仅需10分钟，可同时享受购物与观光的乐趣。',
  about_desc2: '我们提供舒适安逸的客房和多种附属设施，以亲切的服务让您的珍贵旅程更加特别。',
  about_stat1_label: '礼宾服务',
  about_stat2_label: '免费Wi-Fi',
  about_stat3_label: '步行至东大门',
  about_cta: '预订咨询',

  // Rooms
  rooms_tag: '客房介绍',
  rooms_title: '客房介绍',
  rooms_subtitle: '探索英宾酒店舒适温馨的各类客房',
  room1_name: '单人间',
  room1_desc: '专为独自旅行者设计的温馨实用客房，是探索东大门的最佳据点。',
  room2_name: '双床间',
  room2_desc: '配备两张单人床的客房，适合两位旅客入住，宽敞舒适。',
  room3_name: '大床间',
  room3_desc: '配备一张双人床的客房，适合情侣或1-2位旅客，温馨舒适。',
  room4_name: '三人间',
  room4_desc: '配备三张单人床的宽敞客房，最适合三位旅客，适合家庭或小团体旅行。',
  room5_name: '韩式暖炕房',
  room5_desc: '采用韩国传统暖炕地板供暖方式的客房，体验温暖舒适的韩式住宿文化。',
  room6_name: '套房',
  room6_desc: '宽敞豪华的套房，让您的特别旅程更加难忘，配备浴缸和迷你吧。',

  // Services
  svc_tag: '欢迎光临英宾酒店',
  svc_title: '服务设施',
  svc_subtitle: '体验英宾酒店提供的各种优质服务',
  svc1_label: '叫醒服务',
  svc1_desc: '我们将在您希望的时间提供叫醒服务。',
  svc2_label: '24小时礼宾',
  svc2_desc: '24小时随时为您提供帮助，请随时联系我们。',
  svc3_label: '安保管理',
  svc3_desc: '严密的安保系统保障您的安全住宿。',
  svc4_label: '免费Wi-Fi',
  svc4_desc: '全客房提供免费高速Wi-Fi。',
  svc5_label: '桑拿',
  svc5_desc: '您可以使用桑拿设施消除疲劳。',
  svc6_label: '停车场',
  svc6_desc: '为您提供便利的停车空间。',

  // Reservation
  res_tag: '在线预订',
  res_title: '在线预订',
  res_subtitle: '请填写以下表格，我们将尽快与您联系',
  res_name: '姓名',
  res_name_ph: '张三',
  res_phone: '联系电话',
  res_phone_ph: '+82-10-0000-0000',
  res_email: '电子邮件',
  res_checkin: '入住日期',
  res_checkout: '退房日期',
  res_room: '客房类型',
  res_room1: '单人间',
  res_room2: '双床间',
  res_room3: '大床间',
  res_room4: '三人间',
  res_room5: '韩式暖炕房',
  res_room6: '套房',
  res_message: '留言',
  res_message_ph: '请输入其他咨询事项。（最多500字）',
  res_submit: '发送预订咨询',
  res_submitting: '发送中...',
  res_success_title: '您的预订咨询已收到！',
  res_success_desc: '我们将尽快与您联系。',

  // Contact
  contact_tag: '欢迎光临英宾酒店',
  contact_title: '联系我们',
  contact_address_label: '地址',
  contact_address: '首尔特别市中区退溪路56街18号\n（双林洞，英宾酒店）',
  contact_phone_label: '电话 / 传真',
  contact_email_label: '电子邮件',
  contact_checkinout_label: '入住 / 退房',
  contact_checkin: '入住时间: 15:00',
  contact_checkout: '退房时间: 12:00',

  // Footer
  footer_desc: '毗邻东大门国际时装城的英宾酒店。\n桑拿、早餐，步行10分钟至东大门购物商圈。',
  footer_hotel_info: '酒店信息',
  footer_support: '客户支持',
  footer_lang: '语言选择',
  footer_about: '酒店介绍',
  footer_rooms: '客房介绍',
  footer_services: '附属设施',
  footer_contact: '交通指南',
  footer_reserve: '在线预订',
  footer_email_inquiry: '邮件咨询',
  footer_phone_inquiry: '电话咨询',
  footer_copyright: 'Copyright © 英宾酒店. All rights reserved. | 首尔特别市中区退溪路56街18号',
  footer_privacy: '隐私政策',
  footer_terms: '使用条款',
};

export default translation;
